import FAQSection from "@components/FAQSection";
import { faqData } from "./data";
export const  Faq = ()=>{
    return(
        <section className="container"> 

        <FAQSection faqData={faqData} heading='Frequently Asked Questions about Mobile App Development  '   headingFontSize = "text-[30px] md:text-[35px] lg:text-[32px] xl:text-[35px]"
  setStyle={true}/> 
        </section>
    ) 
}  